// extracted by mini-css-extract-plugin
module.exports = {"indicator":"OnsiteIndicatore_indicator__0_Pxj","remix":"OnsiteIndicatore_remix__l6jqm"};